import Global from "@/scripts/Global";
import WeblinkApi from "@/scripts/api/weblink.api";
import {
    serverBus
} from "@/main";
import VueSignals from "@/scripts/VueSignals";
import {
    CPUtils
} from "@/scripts/Utils";
import SessionManager from "@/Manager/Session.manager";

export default {
    name: 'ExternalLinks',
    data() {
        return {
            currData: {
                'ff_name': '',
                'ff_id': '',
                'ff_type': '',
                'folder_id': '',
                'user_rights': [],
            },
            weblinks: [],
            newlink: '',
            Url: Global.GetPortalURL(),
            copied_id: '',
            show_link: '',
            password_protection: true,
            emails: '',
            emails_count: 0,
            max_downloads: '',
            show_right: false,
            selected_right: 'read',
            right_options: [{
                    text: 'read only',
                    value: 'read'
                },
                {
                    text: 'read, write',
                    value: 'write'
                },
                {
                    text: 'read, write, delete',
                    value: 'delete'
                }
            ],
            duration: 4838400,
            durationOptions: CPUtils.getDurationByDay(),
            statue: 'create',
            new_link: false,
        }
    },
    mounted() {
        this.currData = this.$parent.data
        if (this.currData.user_rights.indexOf('write') > -1 ||
            this.currData.user_rights.indexOf('delete') > -1 ||
            this.currData.user_rights.indexOf('transfer') > -1) {
            this.show_right = true
        }
        WeblinkApi.get(this.currData.ff_id, this.currData.ff_type).then(res => {
            if (res.data.result) {
                for (let i = 0; i < res.data.weblinks.length; i++) {
                    this.weblinks.push({
                        'cp_id': res.data.weblinks[i].weblink_id,
                        'link': Global.GetPortalURL() + "/wl/" + this.currData.ff_name + "/" + res.data.weblinks[i].weblink_id,
                        'max_downloads': res.data.weblinks[i].max_downloads,
                        'approved': res.data.weblinks[i].approved,
                        'created': res.data.weblinks[i].created,
                        'password_protection': res.data.weblinks[i].protected,
                        'right': res.data.weblinks[i].right,
                        'views': res.data.weblinks[i].views,
                        'duration': res.data.weblinks[i].valid_until - res.data.weblinks[i].created
                    })
                }
            }
        })

        serverBus.$on(VueSignals.HIDE_COPPIED_EXTERNAL_LINKS, (success) => {
            this.copied_id = ''
        })

        serverBus.$on(VueSignals.WEBLINK_CREATED, (res) => {
            if (typeof res.data != 'undefined' && res.data.status == 200) {
                this.Revoke("newlink")
                this.weblinks.push({
                    'cp_id': res.data.weblink_cp_id,
                    'link': res.data.weblink_url,
                    'password': res.data.weblink_password,
                    'approved': res.data.weblink_approved
                })
                this.statue = 'create'
                Global.globalValue(VueSignals.WEBLINK_CREATED, '')
            }
        })

    },
    methods: {
        Create() {
            // if(!this.weblinks.some(currLink => {return currLink.cp_id == 'newLink'})){
            //     this.weblinks.push({'cp_id': 'newlink', 'link':'', 'password': '', 'approved': true})
            // }
            this.statue = 'confirm'
            this.new_link = true
            this.show_link = 'newlink'
        },
        getDuration(duration) {
            let duration_value = this.durationOptions.find(currDuration => {
                return currDuration.value == duration
            })
            if (typeof duration_value != 'undefined') {
                return duration_value.text
            }
            return ''
        },
        getTime(timestamp) {
            return new Date(timestamp * 1000).toLocaleDateString(SessionManager.getLoggedInUser().chat_visuals.language, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },
        getRight(right) {
            if (right == 'read') {
                return 'Read'
            }

            if (right == 'read, write') {
                return 'Write'
            }

            if (right == 'read, write, delete') {
                return 'Delete'
            }
            return 'none'
        },
        ConfrimCreate() {
            let emails = this.emails.split(",")
            WeblinkApi.create(this.currData.folder_id, this.currData.ff_id, this.currData.ff_type, this.password_protection,
                this.currData.ff_name, this.selected_right, emails, this.max_downloads, this.duration).then(res => {
                if (res.data.result) {
                    for (let i = 0; i < this.weblinks.length; i++) {
                        if (this.weblinks[i].cp_id == 'new_link') {
                            this.weblinks.splice(i, 1)
                        }
                    }
                    this.weblinks.push({
                        'cp_id': res.data.link_id,
                        'password': res.data.password,
                        'approved': res.data.approved,
                        'link': Global.GetPortalURL() + "/wl/" + this.currData.ff_name + "/" + res.data.link_id
                    })
                    this.show_link = ''
                    this.new_link = false
                    this.statue = 'create'
                }
            })
        },
        Revoke(link_id) {
            WeblinkApi.revoke(link_id).then(res => {
                if (res.data.result) {
                    for (let i = 0; i < this.weblinks.length; i++) {
                        if (this.weblinks[i].cp_id == link_id) {
                            this.weblinks.splice(i, 1)
                            break
                        }
                    }
                }
            })
        },
        Copy(link_id) {
            try {
                let weblink = this.weblinks.find(currLink => {
                    return currLink.cp_id == link_id
                })

                if (typeof weblink.password != 'undefined') {
                    document.getElementById(link_id).value += " \u000A " + "password:" + weblink.password
                }

                document.getElementById(link_id).select()
                document.execCommand('copy')
                this.copied_id = link_id
                setTimeout(function() {
                    Global.globalValue(VueSignals.HIDE_COPPIED_EXTERNAL_LINKS, true)
                }, 2000)
            } catch (err) {
                console.log(err)
            }
        },
        show(link_id) {
            this.show_link = link_id
        },
        addEmail() {
            this.emails_count++
            this.emails.push({
                id: this.emails_count,
                email: ''
            })
        },
        deleteInput(id) {
            document.getElementById(id).outerHTML = ""
            this.invitation_input_counter--
            this.input_more.slice(this.input_more.indexOf(this.invitation_input_counter), 1)
        },
        highlightInput(id) {
            document.getElementById(id).classList.add("hoverdanger");
        },
        unHighlightInput(id) {
            document.getElementById(id).classList.remove("hoverdanger");
        }
    }
}
